const Guru = {
    idGuru:null,
    idSekolah:null,
    namaGuru:null,
    usernameGuru:null,
    emailGuru:null,
    handphoneGuru:null,
    passwordGuru:null,
    statusGuru:null,
};

export default Guru;